import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>('div', 'wrapper', 'autocomplete')`
    ${propStyles};
`;
StyledComponent.defaultProps = {
    position: 'relative',
    marginX: 'xs',
    marginY: 'sm',
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/Wrapper.tsx